import dayjs from 'dayjs';

/**
 * Removes undefined and null from a collection of T.
 * @export
 * @template T
 * @param {((T | undefined | null)[])} collection
 * @return {*}  {T[]}
 */
export function safeFilter<T>(collection: (T | undefined | null)[]): T[] {
  return collection.reduce<T[]>((list, element) => {
    if (element) {
      list.push(element);
    }
    return list;
  }, []);
}

/**
 * Removes duplicated strings or numbers from an array
 * @param collection
 * @returns Updated array
 */
export function removeDuplicates(collection: (number | string)[]): (string | number)[] {
  const existingProps: Record<string | number, boolean> = {};
  return collection.filter((item) => {
    if (Object.prototype.hasOwnProperty.call(existingProps, item)) {
      return false;
    }
    existingProps[item] = true;
    return true;
  });
}

/**
 * Formats any date like format to YYYY-MM-DD.
 * @export
 * @param {(string | number | Date | dayjs.Dayjs | null | undefined)} date
 * @return {*}  {string}
 */
export function reverseDateFormat(date: string | number | Date | dayjs.Dayjs | null | undefined): string {
  return dayjs(date).format('DD MMM YYYY');
}

/**
 * Convertys hex value to rgba value.
 * @export
 * @param {string} hex
 * @param {number} [alpha]
 * @return {*}  {string}
 */
export function hexToRGBA(hex: string, alpha?: number): string {
  alpha = alpha ?? 1;
  const hexMatch = hex.match(/\w\w/g);
  if (!hexMatch) {
    return hex;
  }
  const [r, g, b] = hexMatch.map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
}

/**
 * Get an indexes position in a collection.
 * @export
 * @param {number} index
 * @param {number} length
 * @return {*}  {('first' | 'last' | 'middle')}
 */
export function getIndexPosition(index: number, length: number): 'first' | 'last' | 'middle' {
  if (index === 0) {
    return 'first';
  }
  if (index === length - 1) {
    return 'last';
  }
  return 'middle';
}

export const mobileMediaQuery = '@media (max-width: 768px)';
